import LegalLayout from "./LegalLayout";

export default function AgePolicy() {
  return (
    <LegalLayout title="Age Verification & Content Warning" path="/legal/age" description="Age verification and adult content policy. This site contains erotic content and is restricted to legal adults (18+ or older per your jurisdiction).">
      <p>This site contains adult material relating to consensual erotic hypnosis. You must be 18 or older - and of legal age in your jurisdiction - to enter. By continuing you confirm that you are.</p>
      <p>Access to the site is conditional on this confirmation. If you are uncertain, please leave the site.</p>
      <p>All depicted activities are between consenting adults. Recordings, where produced, exist only with signed Release Agreements specifying usage and distribution.</p>
    </LegalLayout>
  );
}
